// Import resource card images
import specificationLibraryImage from '../../assets/backgroundImages/resourcePageImages/1_specificationLibrary.jpg';
import kitchenDesignContestImage from '../../assets/backgroundImages/resourcePageImages/2_kitchenDesignContest.jpg';
import revealCabinetryImage from '../../assets/backgroundImages/resourcePageImages/3_revealCabinetrySpecifications.jpg';
import brochureMakerImage from '../../assets/backgroundImages/resourcePageImages/4_brochureMaker.jpg';
import futureProductsImage from '../../assets/backgroundImages/resourcePageImages/5_futureProducts.jpg';
import mobileAppImage from '../../assets/backgroundImages/resourcePageImages/6_MobileSpecificationApp.jpg';
import inspirationGalleryImage from '../../assets/backgroundImages/resourcePageImages/7_inspirationGallery.jpg';
import livingKitchenImage from '../../assets/backgroundImages/resourcePageImages/8_livingKitchen.jpg';

export interface ResourceCard {
  id: string;
  titleKey: string;
  descriptionKey: string;
  imageUrl: string;
  link: string;
}

export const resourceCards: ResourceCard[] = [
  {
    id: '1',
    titleKey: 'resource:cards.specificationLibrary.title',
    descriptionKey: 'resource:cards.specificationLibrary.description',
    imageUrl: specificationLibraryImage,
    link: 'https://ca.subzero-wolf.com/en/trade-resources/product-specifications'
  },
  {
    id: '2',
    titleKey: 'resource:cards.kitchenDesignContest.title',
    descriptionKey: 'resource:cards.kitchenDesignContest.description',
    imageUrl: kitchenDesignContestImage,
    link: 'https://www.subzero-wolf.com/trade-resources/kitchen-design-contest'
  },
  {
    id: '3',
    titleKey: 'resource:cards.revealCabinetry.title',
    descriptionKey: 'resource:cards.revealCabinetry.description',
    imageUrl: revealCabinetryImage,
    link: 'https://ca.subzero-wolf.com/en/trade-resources/reveal '
  },
  {
    id: '4',
    titleKey: 'resource:cards.brochureMaker.title',
    descriptionKey: 'resource:cards.brochureMaker.description',
    imageUrl: brochureMakerImage,
    link: 'https://ca.subzero-wolf.com/en/trade-resources/brochure-maker/product-select'
  },
  {
    id: '5',
    titleKey: 'resource:cards.futureProducts.title',
    descriptionKey: 'resource:cards.futureProducts.description',
    imageUrl: futureProductsImage,
    link: 'https://ca.subzero-wolf.com/en/trade-resources/future-product-update'
  },
  {
    id: '6',
    titleKey: 'resource:cards.mobileApp.title',
    descriptionKey: 'resource:cards.mobileApp.description',
    imageUrl: mobileAppImage,
    link: 'https://ca.subzero-wolf.com/en/trade-resources/specifications-app'
  },
  {
    id: '7',
    titleKey: 'resource:cards.inspirationGallery.title',
    descriptionKey: 'resource:cards.inspirationGallery.description',
    imageUrl: inspirationGalleryImage,
    link: 'https://www.subzero-wolf.com/inspiration/kitchens#numberOfResults=20'
  },
  {
    id: '8',
    titleKey: 'resource:cards.livingKitchen.title',
    descriptionKey: 'resource:cards.livingKitchen.description',
    imageUrl: livingKitchenImage,
    link: 'https://lifestyle.subzero-wolf.com'
  }
];
